// laboratory-lib's createClient defaults to an IndexedDB-backed SuperStore.
// Headless crawlers (e.g. Lightpanda) lack IndexedDB, so the store rejects with
// "IndexedDB is not supported in this environment." as an unhandled rejection.
// Callers use this to fall back to an in-memory store instead.
export function isIndexedDBSupported() {
  try {
    return typeof window !== 'undefined' && Boolean(window.indexedDB);
  } catch (_unused) {
    return false;
  }
}